/**
 * Представление для работы с окном Редактирование отзыва
 *
 * @author Каймонов Владимир
 *
 */
(function ($) {

    var selectorContainer = '.docdoc_container',
        $container = $(selectorContainer),
        idDialog = '#dialog-sber-health-appointment',
        subscribeIsExecuted = false,


        $dialog = $(idDialog)
            .dialog({
                dialogClass: "docdoc",
                modal: true,
                autoOpen: false,
                resizable: false,
            }),


        /**
         * Клик на кнопку 'Записаться на прием'
         */
        eventShowClick = function () {

            $container.off('click', '.js-btn-sber-health');
            $container.on('click', '.js-btn-sber-health', function (event) {
                event.preventDefault();

                $('.docdoc_frame').attr('src', 'https://medelement.com/sberdoc');
                $dialog.dialog("open");

                event.stopPropagation();
            });

        },


        /**
         * Клика на кнопку 'Закрыть'
         */
        eventButtonCloseClick = function () {

            $dialog.off('click', '#btn-close');
            $dialog.on('click', '#btn-close', function (event) {
                event.preventDefault();

                $dialog.dialog("close");

                event.stopPropagation();
            });

        },


        /**
         * Инициализирует представление
         */
        init = function () {
            if (!subscribeIsExecuted) {
                eventShowClick();
                eventButtonCloseClick()

                subscribeIsExecuted = true;
            }
        };

    init();

}(jQuery));

